var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1UsbKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h-5V9H27v17h-5v27.13a16 16 0 1032 0V26zM41 14h3v8h-3v-8zm-9 0h3v8h-3v-8zm6 51.13a12 12 0 01-12-12V30h24v23.13a12 12 0 01-12 12zm3-8.25a3 3 0 11-5.999 0 3 3 0 015.999 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_USB_key.29edf252.svg";
export { SvgH1UsbKey as ReactComponent };